export default __webpack_public_path__ + "static/media/thumbnail-w-chair@2x.50ebb0de.png";